<template lang="pug">
.reservation-message-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    template(#modal-title)
      span 以下の外出外泊届けを一括承諾します。よろしいですか？

    OutingTable(v-model="items" :fields="fields")

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(@click="ok") OK
      b-button.btn.modal-cancel-btn(@click="cancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import OutingTable, { OutingTableField, OutingTableItem } from "@/pc/containers/outings/OutingTable.vue";

/**
 * ### 外出外泊一括承諾モーダル
 */
@Component({
  components: {
    OutingTable
  }
})
export default class MessageModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 行情報 */
  @Prop()
  items!: Array<OutingTableItem>;

  /** 列名 */
  fields: Array<OutingTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _rows() {
    return this.items.length;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    const fields: Array<OutingTableField> = this.createFields();
    this.fields = fields;
    return;
  }

  /**
   * ### 列を作成する
   */
  public createFields(): Array<OutingTableField> {
    const fields: Array<OutingTableField> = [];
    fields.push({ key: "type", label: "種別", sortable: false, sortDirection: "desc", class: "type text-center" });
    fields.push({ key: "datetimes", label: "日時", sortable: false, sortDirection: "desc", class: "datetimes" });
    fields.push({ key: "resident", label: "", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "applicant", label: "", sortable: false, sortDirection: "desc", class: "applicant" });
    return fields;
  }

  public async ok(): Promise<void> {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
